import { faRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function RotateBox(props: {visible: boolean}) {
    return (
        <div data-html2canvas-ignore className="rotate-box" style={{visibility: props.visible ? 'visible' : 'hidden', position: 'absolute', left: '50%', top: '-25px', transform: 'translate(-50%, -50%)', color: 'black'}}>
            <div><FontAwesomeIcon icon={faRotate} /></div>
        </div>
    )
}